import React, { useState } from 'react'
import netWestLogo from "../../../assets/images/natwest-logo.png" 
import { toast } from 'react-toastify';

const PaymentSection = ({ selected_course, setdiscount, price, setPrice, setstep, code, setcode, CheckCode, loading,isFromCourse }) => {

    const [selectedGateway, setSelectedGateway] = useState('');  

    const handleGatewaySelect = (gateway) => {
        setSelectedGateway(gateway);
    }; 

    return (
        <div className='contact-section pt-0'>
            <div>
                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>Select Payment Gateway</h2>
                <p >Just a few questions to determine the type of lesson or course you would like.</p>
            </div>

            <div className="payment-options-container mt-4">
                <div className="gateway-cards">
                    <div
                        className={`gateway-card ${selectedGateway === 'natwest' ? 'selected' : ''}`}
                        onClick={() => handleGatewaySelect('natwest')}
                    >
                        <img src={netWestLogo} alt="NatWest TY22" />
                        <h3>£{Number(price) !== Number(selected_course?.price) && <span className='Old-Price fs-2 px-2'> {Number(selected_course?.price).toFixed(2)} </span>} {Number(price).toFixed(2)}</h3>
                        <p>Secure and fast payments with NatWest.</p>
                    </div>

                </div>
                <div className='form-inner px-0 py-0 mt-5'>
                    <div className="row clearfix">
                        <div className="input-field d-flex gap-3 form-group" >
                            <input
                                type="text"
                                name="Promo Code"
                                value={code}
                                disabled={price < selected_course?.price}
                                onChange={(e) => setcode(e.target.value)}
                                placeholder="Promo Code"
                            />
                            <button className="theme-btn-promo text-white ps-3" disabled={price < selected_course?.price} type='button' onClick={CheckCode}>
                                Apply
                            </button>
                            {
                                price < selected_course?.price && (
                                    <button className="bg-black text-white" style={{ padding: "10px 15px" }} type='button' onClick={() => {
                                        setdiscount(0)
                                        setPrice(selected_course?.price)
                                        setcode('')
                                        toast.success("Promo Code Removed");
                                    }}>
                                        Clear
                                    </button>
                                )}
                        </div>
                    </div>
                </div>
                <div className='mt-5 d-flex justify-content-between'>
                    <button className="theme-btn btn-two" type='button' onClick={() => {
                        if (isFromCourse)
                            setstep(1)
                        else
                            setstep(prev => prev - 1);
                    }}>
                        <i className='bi bi-arrow-left me-2 fs-6'></i>Back
                    </button>
                    <button disabled={!selectedGateway || loading} className="continue-btn">
                        Continue to pay with {selectedGateway ? selectedGateway.toUpperCase() : '...'}
                    </button>
                </div>
            </div>

        </div>
    )
}

export default PaymentSection